import { useAppStore } from 'kfone-frontend-core';
import RedirectToLoginPage from 'pages/redirect-to-login';
/** @jsxRuntime classic */
import React from 'react';
import type { FC } from 'react';

export const withAuthorization = <P extends object>(WrappedComponent: FC<P>) => {
  const ComponentWithAuthorization: FC<P> = (props) => {
    const { isAuthenticated } = useAppStore();

    // Commented to give direct access for testing
    // if (isAuthenticated ||  (window.location.hostname === 'localhost' && window.location.port === '3090')) {
    //   return <WrappedComponent {...props} />;
    // }

    // return <RedirectToLoginPage />;
    return <WrappedComponent {...props} />; 
  };

  ComponentWithAuthorization.displayName = `withAuthorization(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;
  return ComponentWithAuthorization;
};